import { FullPageContainer } from 'components/Container';
import Header from 'components/Header';
import Head from 'next/head';
import React, { ReactElement } from 'react';
import { SunsetBanner } from 'screens/organisations/dashboard/SetupNotificationsPromptBanner';
import Signup from 'screens/signup';

export default function SignupPage() {
	return <Signup />;
}

SignupPage.getLayout = function getLayout(page: ReactElement) {
	return (
		<>
			<Head>
				<title>Signup to Coinshift</title>
				<meta name='description' content='Coinshift' />
				<link rel='icon' href='/favicon.ico' />
			</Head>
			<SunsetBanner />
			<FullPageContainer style={{ paddingTop: '40px' }}>
				<Header />
				{page}
			</FullPageContainer>
		</>
	);
};
